module.exports = __webpack_public_path__ + "img/google-chrome.5dc92736.svg";